import { debounceTime } from "rxjs/operators";
import { DropdownComponent } from "../dropdown.component";
import { DropdownController } from "./dropdown-controller.interface";
import { GISConfig, GISOptions, ensureOptionsExist } from "../../../../gis/models/gis-config.model";
import { GISControllerService } from "../../../services/GIS-controller.service";
import { WellConfigurationIndex } from "../../new-casing-plan/models/casing-plan.model";
import { deepClone } from "../../../../builder/models/editor.model";

export class GISDropdownController implements DropdownController {
    component: DropdownComponent;
    config: GISConfig;
    _options: GISOptions;

    get options() { return this._options; }

    constructor(readonly service: GISControllerService) {
        this.config = window["GIS.Conf"] as GISConfig;
    }

    onInit(): void {
        if (this.component.enableEditing) {

            let contextTarget = this.component.componentData.contextTarget;
            let x = this.service.getContextTarget(WellConfigurationIndex.LongitudeDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.LongitudeHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.LongitudeVertical, this.options);

            let y = this.service.getContextTarget(WellConfigurationIndex.LatitudeDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.LatitudeHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.LatitudeVertical, this.options);

            let plane = this.service.getContextTarget(WellConfigurationIndex.StatePlaneDirectional, this.options) || this.service.getContextTarget(WellConfigurationIndex.StatePlaneHorizontal, this.options)
                || this.service.getContextTarget(WellConfigurationIndex.StatePlaneVertical, this.options);

            if (x === contextTarget || y === contextTarget || plane === contextTarget) {
                let previous = deepClone(this.service.contextService.getContextData(`${contextTarget}.value`, this.component.componentContext));
                this.component.control.valueChanges.pipe(debounceTime(1000)).subscribe((data) => {
                    if (previous !== "" && data !== previous) {
                        previous = data;
                        this.service.clear(this.options);
                    }
                });
            }
        }
    }

    afterViewInit() {
        if (this.component.enableEditing) {

            //Attempt to execute the query on initialization if the fields are set
            this.queryCoordinates();
        }
    }

    setup(args: any) {
        this._options = ensureOptionsExist(args);
    }


    change(): void {
        if (this.component && this.component.componentData && this.component.enableEditing) {
            this.queryCoordinates();
        }        
    }

    queryCoordinates(): void {
        this.service.context = this.component.componentContext;
        this.service.loader.toggleLoader(true);
        try {
            this.service.queryCoordinates(this.options, this.config).then(result => {
                this.service.loader.toggleLoader(false);
            }, (rej) => {
                this.service.loader.toggleLoader(false);
            });
        }
        catch (error) {
            console.error(error);
            this.service.loader.toggleLoader(false);
        }
    }
}